import type { JSX } from 'react'
import type { IDropdownItemTypeButtonProps } from '../DropdownItemTypeButton'

import {
  DropdownItemBackgrounds,
  DropdownItemFontColors,
  DropdownItemFonts,
  DropdownItemPaddings,
} from '../../DropdownItem.h'
import { DropdownItemTypeButton } from '../DropdownItemTypeButton'

export interface IDropdownItemNavBarProps extends IDropdownItemTypeButtonProps {}

export const DropdownItemNavBar = ({
  title = '',
  font = DropdownItemFonts.Body4,
  paddings = DropdownItemPaddings.SIZE_0,
  colorDefault,
  colorHovered = DropdownItemFontColors.SURFACE_LIGHT_2,
  colorPressed = DropdownItemFontColors.BASE_MAIN_PRESSED,
  colorSelected: _unused = DropdownItemFontColors.TEXT_ICON_PRIMARY,
  backgroundHovered = DropdownItemBackgrounds.TRANSPARENT,
  backgroundPressed = DropdownItemBackgrounds.TRANSPARENT,
  ...rest
}: IDropdownItemNavBarProps): JSX.Element => (
  <DropdownItemTypeButton
    title={title}
    font={font}
    colorDefault={colorDefault}
    colorHovered={colorHovered}
    colorPressed={colorPressed}
    backgroundHovered={backgroundHovered}
    backgroundPressed={backgroundPressed}
    paddings={paddings}
    {...rest}
  />
)
